import { Linking } from 'react-native';

import { fromCallback } from 'xstate';

import { checkIfAdjustLink } from '../utils/adjust-link';
import { type AdjustEvent } from './adjust-initialization-machine.events';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Forwards Adjust links that opened the app to the machine.
 */
const listenForAdjustLinks = fromCallback<AdjustEvent>(({ sendBack }) => {
  const handleAdjustDeepLink = (url: string | null | undefined) => {
    if (!url || !checkIfAdjustLink(url)) return;

    sendBack({ type: 'DEEPLINK_RECEIVED', url });
  };

  void Linking.getInitialURL().then((url) => {
    if (!url || url === handledInitialUrl) return;

    handledInitialUrl = url;
    handleAdjustDeepLink(url);
  });

  const subscription = Linking.addEventListener('url', ({ url }) => {
    handleAdjustDeepLink(url);
  });

  return () => {
    subscription.remove();
  };
});

// edge case: to avoid handling the same URL twice if the listener restarts (feature flag switch on -> off -> on).
let handledInitialUrl: string | null = null;

export const AdjustInitializationActors = { listenForAdjustLinks };
